<template>
  <div class="content" id='qa'>
    <h2 class="m-n">Q&A</h2>
    <div v-if="pageData.length && latestUpdated" style="padding: 20px">最終更新日： {{ latestUpdated }}</div>
    <div class="hpanel panel-group" id="accordion" role="tablist" aria-multiselectable="true">
      <template v-for="item in pageData">
        <div class="panel-body" :key="item.groupId">
          <h4 class="m-t-none m-b-none" v-html="replaceHTMLSellerInfo(item.groupName)"></h4>
        </div>
        <div class="panel-body qa-block" v-for="(qaData, index) in item.data" :key="item.groupId + '-' + index">
          <div data-toggle="collapse" data-parent="#accordion" :data-target="'#answer-' + item.groupId + '-' + index" aria-expanded="false" class="question collapsed m-l pointer-cursor accordion-title">
            <div v-html="replaceHTMLSellerInfo(qaData.title)"></div>
            <i class="fa fa-chevron-down accordion-arrow text-muted"></i>
          </div>
          <div :id="'answer-' + item.groupId + '-' + index" class="panel-collapse collapse m-l" aria-expanded="true">
            <hr>
            <div class="m-l" v-html="replaceHTMLSellerInfo(qaData.content)"></div>
          </div>
        </div>
      </template>
    </div>

    <div>
      <pagination
        :url="'QA/list'"
        @onChangePage="onChangePage"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/PaginationLoadMore'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  data () {
    return {
      pageData: [],
      latestUpdated: ''
    }
  },
  components: {
    Pagination
  },
  methods: {
    replaceHTMLSellerInfo,
    /*
     * Handle on page change
     *
     * @param {Array} data Data from API
     *
     * @return void
     */
    onChangePage (data) {
      this.pageData = [...data]
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.show_screen_question_and_answer,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    this.$events.listen('apiSuccess', (url, response) => {
      this.latestUpdated = response.latestUpdated
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/view/QuestionAnswer.vue